import React from "react";
import PayPeriodSelector from "@/components/PayPeriodSelector";
import MonthSelector from "@/components/MonthSelector";

/**
 * Cadence-aware wrapper around PayPeriodSelector / MonthSelector.
 * Determines the flavour from `cadence` and dispatches the right dropdown.
 * Both children expose the same {value, onChange, published} contract.
 */
export default function PeriodSelector({ cadence, periods, value, onChange, published }) {
  if (cadence === "monthly") {
    return <MonthSelector months={periods} value={value} onChange={onChange} published={published} />;
  }
  return <PayPeriodSelector periods={periods} value={value} onChange={onChange} published={published} />;
}
